import { Approbation } from '../../approbations/models/approbation.model';
import { Class } from '../../classes/models/class.model';
import { DiscountCode } from '../../discounts/models/discount-code.model';
import { Edition } from '../../editions/models/edition.model';
import { EnrollmentPaymentInfo } from './enrollment-paymentinfo.model';
import { Known } from '../../knowns/models/known.model';
import { Student } from '../../students/models/student.model';
import { EnrollmentNewRequest } from './api/enrollment-new-request.model';

export class EnrollmentNew {

    code                : string;
    edition             : Edition;
    student             : Student;
    known               : Known;
    classes             : Class[];
    discountCodes       : DiscountCode[];
    totalDiscount       : number = 0;
    conditionsChecked   : boolean = false;
    authorizationChecked: boolean = false;
    approbations        : Approbation[];
    paymentInfo         : EnrollmentPaymentInfo;

    public static mapToApiRequest(item: EnrollmentNew) : EnrollmentNewRequest {

        let request = new EnrollmentNewRequest();
            request.editionId    = item.edition.editionId;
            request.studentId    = item.student.studentId;
            request.knownId      = item.known.knownId;
            request.paymentInfo  = item.paymentInfo;
            request.classes      = item.classes;
            request.discountCodes= item.discountCodes;
            request.approbations = item.approbations;

        return request;

    }

}
